import type { GameContext } from '../core/context';
import type { System } from '../core/system';

/** Steps the physics world and forwards contacts / trigger changes to the event bus. Order 400. */
export function createPhysicsSystem(): System {
  let ctx: GameContext;
  return {
    id: 'physics',
    order: 400,
    init(c) {
      ctx = c;
      c.hooks.registerSnapshot('physics', () => ({ ...c.physics.stats }));
    },
    fixedUpdate(dt) {
      const physics = ctx.physics;
      physics.step(dt);
      const events = ctx.events;
      for (const c of physics.contacts) {
        if (!c.isNew && c.speed < 1) continue;
        events.emit('collision', { a: c.a, b: c.b, impulse: c.impulse, speed: c.speed, pos: c.pos, normal: c.normal, isNew: c.isNew });
      }
      for (const t of physics.triggerEvents) {
        const payload = { triggerId: t.triggerId, triggerTag: t.triggerTag, body: t.body };
        events.emit(t.type === 'enter' ? 'triggerEnter' : 'triggerExit', payload);
      }
    },
  };
}
